import { render, staticRenderFns } from "./ApfEbisSupportingDocument.vue?vue&type=template&id=50b65eff"
import script from "./ApfEbisSupportingDocument.vue?vue&type=script&lang=js"
export * from "./ApfEbisSupportingDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports